import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class HowShadowerWorksPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Getting Started</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>How Shadower Works</div>

                <img
                  alt="Music producers"
                  src="/assets/images/handbook/music-producer@1280x600.jpg"
                />

                <p>
                  Shadowing sessions are a unique learning experience, intended
                  to provide amateurs knowledge, experience and connections not
                  readily available elsewhere. As their instructor, you get to
                  facilitate this unique learning opportunity within your local
                  community.
                </p>

                <p>
                  One of the strengths of Shadower is the flexibility it
                  provides its experts. As an expert you have full control over
                  nearly every aspect of the session including:
                </p>
                <ul>
                  <li>
                    Level of interactivity:
                    <p>
                      Sessions can range from observation-only to fully
                      interactive.
                    </p>
                  </li>

                  <li>
                    Price:
                    <p>
                      You set your own rate and keep 90 percent of whatever you
                      charge.
                    </p>
                  </li>

                  <li>
                    Length:
                    <p>Sessions can be as short or as long as you want.</p>
                  </li>

                  <li>
                    Private or public:
                    <p>
                      You can create one-on-one private sessions or open them to
                      the public by allowing two or more shadowers.
                    </p>
                  </li>

                  <li>
                    Location:
                    <p>
                      You can offer shadowing at your workplace, home office,
                      home studio or even at your shadower's home.
                    </p>
                  </li>

                  <li>
                    Provisions:
                    <p>
                      You can choose to provide shadowers as much or as little
                      as you want.
                    </p>
                  </li>

                  <li>
                    Number of shadowers:
                    <p>
                      You can choose how many people are allowed per session.
                    </p>
                  </li>
                </ul>

                <p>
                  As an expert, you can create an unlimited number of unique
                  shadowing sessions, each with their own title, description,
                  price and restrictions.
                </p>

                <div className={s.contentContainer}>
                  <div>
                    <strong>An Overview of Your Next Steps</strong>
                  </div>
                  <p>
                    Here are the general steps to get you ready for your first
                    shadower.
                  </p>

                  <ol>
                    <li> Sign up</li>
                    <li> Fill out your user profile</li>
                    <li> Create and fill out a shadowing profile</li>
                    <li>
                      {' '}
                      Create your shadowing schedule with individual sessions
                    </li>
                    <li> Connect a Stripe account</li>
                    <li> Promote your profile</li>
                  </ol>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/getting-started/working-with-businesses"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(HowShadowerWorksPage);
